export const sportsOptions = [
    {
        name: 'American Football',
        key: 'americanfootball'
    },
    {
        name: 'Athletics',
        key: 'athletics'
    },
    {
        name: 'Australian Rules',
        key: 'australianrules'
    },
    {
        name: 'Badminton',
        key: 'badminton'
    },
    {
        name: 'Baseball',
        key: 'baseball'
    },
    {
        name: 'Basketball',
        key: 'basketball'
    },
    {
        name: 'Bowls',
        key: 'bowls'
    },
    {
        name: 'Boxing',
        key: 'boxing'
    },
    {
        name: 'Cricket',
        key: 'cricket'
    },
    {
        name: 'Cycling',
        key: 'cycling'
    },
    {
        name: 'Darts',
        key: 'darts'
    },
    {
        name: 'Esports',
        key: 'esports'
    },
    {
        name: 'Football',
        key: 'football'
    },
    {
        name: 'Formula One',
        key: 'formulaone'
    },
    {
        name: 'Gaelic Football',
        key: 'gaelicfootball'
    },
    {
        name: 'Gaelict Hurling',
        key: 'gaelichurling'
    },
    {
        name: 'Greyhounds',
        key: 'greyhoundracing'
    },
    {
        name: 'Golf',
        key: 'golf'
    },
    {
        name: 'Handball',
        key: 'handball'
    },
    {
        name: 'Horse Racing',
        key: 'horseracing'
    },
    {
        name: 'Ice Hockey',
        key: 'icehockey'
    },
    {
        name: 'International Greyhoundracing',
        key: 'internationalgreyhoundracing'
    },
    {
        name: 'International Horse Racing',
        key: 'internationalhorseracing'
    },
    {
        name: 'Motor Racing',
        key: 'motorsport'
    },
    {
        name: 'Mixed Martial Arts',
        key: 'mixedmartialarts'
    },
    {
        name: 'Olympics',
        key: 'olympics'
    },
    {
        name: 'Politics',
        key: 'politics'
    },
    {
        name: 'Pool',
        key: 'pool'
    },
    {
        name: 'Rugby League',
        key: 'rugbyleague'
    },
    {
        name: 'Rugby Union',
        key: 'rugbyunion'
    },
    {
        name: 'Snooker',
        key: 'snooker'
    },
    {
        name: 'Table Tennis',
        key: 'tabletennis'
    },
    {
        name: 'Tennis',
        key: 'tennis'
    },
    {
        name: 'Tennis Doubles',
        key: 'tennisdoubles'
    },
    {
        name: 'TV & Specials',
        key: 'tvspecials'
    },
    {
        name: 'Volleyball',
        key: 'volleyball'
    }
];

export const racingOptions = [
    {
        name: 'Horse Racing',
        key: 'horseracing'
    },
    {
        name: 'Greyhounds',
        key: 'greyhoundracing'
    },
];
